<template>
  <div class="d-flex col-md-6 justify-space-between align-center wrapper">
    <div
      v-if="!isMobile"
      class="markero-logo col-6 pa-0 px-10"
    >
      <r-img
        alt="Company Registration Logo"
        :src="markero"
        cover
      />
    </div>
    <div class="h-full col-md-6 flex-column d-flex justify-space-between pa-4">
      <ProductFinder />
      <div class="d-flex flex-wrap justify-center mb-4">
        <IubendaDocumentLink
          type="terms"
          class="mx-1 mx-sm-2"
          @click.stop
        />
        <IubendaDocumentLink
          class="mx-1 mx-sm-2"
          type="privacyPolicy"
          @click.stop
        />
        <IubendaConsentLink class="mx-1 mx-sm-2" />
        <a
          :href="imprintUrl"
          target="_blank"
          class="mx-1 mx-sm-2 text-primary"
          rel="noopener noreferrer"
          >{{ $t('navigation.labels.imprint') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import markero from '@/assets/img/markero-registration.png'
import ProductFinder from '@/components/product-finder/ProductFinder.vue'
import brandingMixin from '@/mixins/branding'
import IubendaConsentLink from '@/modules/iubenda/ConsentPreferencesLink.vue'
import IubendaDocumentLink from '@/modules/iubenda/DocumentLink.vue'

export default {
  components: {
    IubendaConsentLink,
    IubendaDocumentLink,
    ProductFinder,
  },
  mixins: [brandingMixin],
  data() {
    return {
      markero,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.display.mobile
    },
  },
}
</script>

<style scoped>
.wrapper {
  background-color: white;
}
.wrapper,
.markero-logo {
  height: 100vh;
}
@media (min-width: 600px) {
  .wrapper > * {
    width: 50%;
  }
}
.markero-logo {
  background-color: #f9b004;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
</style>
